module.exports = __webpack_public_path__ + "static/img/2020-12-13 12.47.33.f08f8b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/2020-12-13 12.47.33.jpg
// module id = vqz+
// module chunks = 4